import React, { Component } from "react";
import { Card, Icon, Table } from "antd";
import axios from "axios";

import Pagination from "../../components/pagination";
import { Translate } from "react-translated";
import F from "../../Functions";
import DataHandler from "../../utils/DataHandler";

class DncCustomers extends Component {
  state = {
    loading: true,
    bfiles: [],
    page: 1,
    total_pages: 0,
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.getDncBFiles(1);
      DataHandler.setDncCustomerCallback(this.getDncBFiles);
    }
  };

  componentDidMount = () => { 
    this.getDncBFiles(1);

    // set Dnc Customer allback
    DataHandler.setDncCustomerCallback(this.getDncBFiles);

    // const res = {};

    // res["data"] = {
    //   num_results: 1,
    //   objects: [
    //     {
    //       acknowledge_by: 0,
    //       action: null,
    //       action_date: null,
    //       address: null,
    //       address_cont: null,
    //       agency: {
    //         active: 1,
    //         address: null,
    //         billing_address: null,
    //         calculator_only: 0,
    //         created_on: "2016-03-02T09:54:56-05:00",
    //         email_status: 0,
    //         facebook: "http://www.facebook.com",
    //         id: 1,
    //         linkedin: "http://www.linkedin.com",
    //         name: "FB-Test Insurance Agency",
    //         onboard_calls_time: null,
    //         primary_ea_id: 19,
    //         region: null,
    //         review: 1,
    //         state: null,
    //         tier: null,
    //         twitter: "http://www.twitter.com",
    //         updated_on: "2016-03-02T09:54:56-05:00",
    //         vonboard: 1,
    //       },
    //       agency_id: 1,
    //       archive: 0,
    //       asset_401k_accounts: null,
    //       asset_401k_accounts_spouse: null,
    //       asset_401k_accounts_toggle: null,
    //       asset_401k_accounts_toggle_spouse: null,
    //       asset_401k_value: 0,
    //       asset_accounts: null,
    //       asset_accounts_spouse: null,
    //       asset_preservation_toggle: null,
    //       asset_preservation_value: null,
    //       asset_preservation_value_spouse: null,
    //       asset_total_value: null,
    //       asset_total_value_spouse: null,
    //       attempts: null,
    //       attention: [],
    //       auto_carrier: null,
    //       auto_expiration_date: null,
    //       auto_liability: null,
    //       auto_policy_not_sold_current_carrier: null,
    //       auto_policy_not_sold_current_liability_limit: null,
    //       auto_policy_not_sold_expiration_date: null,
    //       auto_policy_sold_bfile_limit: null,
    //       auto_policy_sold_current_liability_limit: null,
    //       auto_policy_sold_effective_date: null,
    //       auto_policy_sold_items_sold: null,
    //       auto_policy_sold_liability_limit_sold: null,
    //       auto_policy_sold_policy_premium: null,
    //       auto_policy_sold_term: null,
    //       auto_sold_toggle: null,
    //       bfile_folow_up_completed: null,
    //       bfile_need_attention: [],
    //       birthday: null,
    //       business_loan_toggle: null,
    //       business_name: null,
    //       business_name_spouse: null,
    //       business_owner_spouse_toggle: null,
    //       business_owner_toggle: null,
    //       business_retirement_value: null,
    //       business_type: null,
    //       business_type_other: null,
    //       business_type_other_spouse: null,
    //       business_type_spouse: null,
    //       calendly_eventdate: null,
    //       calendly_eventuri: null,
    //       calendly_location: null,
    //       call_type: null,
    //       callback_time: null,
    //       callbacks: [],
    //       children: null,
    //       children_living_home_toggle: null,
    //       childs: [],
    //       city: null,
    //       coverage_detail_toggle: null,
    //       created_on: "2023-06-22T08:55:04-04:00",
    //       cross_sell: [],
    //       cross_sell_opportunities_quoted: 0,
    //       cross_sell_opportunities_sold: 0,
    //       cross_sell_policies_uncovered: 0,
    //       deleted: 0,
    //       dnc_status: true,
    //       dnc_type: "manual",
    //       ea: null,
    //       ea2: null,
    //       ea_id: null,
    //       ea_id2: null,
    //       efs: null,
    //       efs2: null,
    //       efs_id: null,
    //       efs_id2: null,
    //       email: "moin@gmail.com",
    //       employed_anual_income: null,
    //       employed_anual_income_spouse: null,
    //       employed_length: null,
    //       employed_length_spouse: null,
    //       employed_retired_disabled: null,
    //       employed_retired_disabled_spouse: null,
    //       employed_toggle: null,
    //       employed_toggle_spouse: null,
    //       employees_count: null,
    //       employees_count_spouse: null,
    //       employer_name: null,
    //       employer_name_spouse: null,
    //       employer_retire_from: null,
    //       employer_retire_from_spouse: null,
    //       employer_years: null,
    //       employer_years_spouse: null,
    //       expiration_date: "2023-08-06T00:00:00",
    //       facebook: null,
    //       financial_calls_attempts: 0,
    //       financial_conversion: [],
    //       financial_id: null,
    //       financial_user: null,
    //       first_name: "RR",
    //       had_mortgage_review: null,
    //       home_bfile_liability: null,
    //       home_liability: null,
    //       home_liability_sold: null,
    //       home_market_value: null,
    //       home_mortgage: null,
    //       home_mortgage_protection_benefit: null,
    //       home_mortgage_protection_benefit_spouse: null,
    //       home_mortgage_protection_policy: null,
    //       home_mortgage_protection_policy_spouse: null,
    //       home_mortgage_protection_toggle: null,
    //       home_mortgage_protection_toggle_spouse: null,
    //       home_mortgage_toggle: null,
    //       home_policy_not_sold_current_carrier: null,
    //       home_policy_not_sold_current_liability_limit: null,
    //       home_policy_not_sold_expiration_date: null,
    //       home_policy_premium: null,
    //       home_policy_sold_bfile_limit: null,
    //       home_policy_sold_effective_date: null,
    //       home_policy_sold_items_sold: null,
    //       home_policy_sold_liability_limit: null,
    //       home_policy_sold_liability_limit_sold: null,
    //       home_policy_sold_policy_premium: null,
    //       home_policy_sold_term: null,
    //       home_sold_toggle: null,
    //       home_toggle: null,
    //       id: 375772,
    //       insurance_score: null,
    //       internet_leads: 0,
    //       invite_password: null,
    //       is_appointment_kept: 0,
    //       is_appointment_made: 0,
    //       is_appointment_sold: 0,
    //       is_lead: 0,
    //       is_onboarded: null,
    //       is_renewal: 1,
    //       is_requote: 0,
    //       is_saved_for_later: 0,
    //       is_sent_to_financial: 0,
    //       language: null,
    //       last_bfile_id: null,
    //       last_name: "DD",
    //       liability_calculator_value: null,
    //       life_opportunities: 0,
    //       life_opportunities_received: 0,
    //       life_opportunities_sold: 0,
    //       linkedin: null,
    //       lsp: null,
    //       lsp2: null,
    //       lsp_id: null,
    //       lsp_id2: null,
    //       mb_archived: null,
    //       merged_with_parent_id: null,
    //       mortgage_purchase_home: null,
    //       mortgage_referral: null,
    //       mortgage_review: null,
    //       mortgage_review_approved: null,
    //       need_attention: 0,
    //       no_follow_up: null,
    //       no_policies_sold: 0,
    //       nosalearchive_expiration_date: null,
    //       not_interested: 0,
    //       onboarder: null,
    //       onboarder_id: null,
    //       onboarding_id: null,
    //       onboarding_user: null,
    //       parent_id: null,
    //       personal_property_toggle: null,
    //       personal_property_type: null,
    //       personal_property_value: null,
    //       phone: "5378954267",
    //       phone2: null,
    //       policies: [],
    //       policy_umbrella_total: 0,
    //       primary_vehicles_num: null,
    //       primary_vehicles_toggle: null,
    //       profile_photo: null,
    //       questions: [],
    //       quote_auto_toggle: null,
    //       quote_home_toggle: null,
    //       referral_data: [],
    //       referral_id: null,
    //       renewals: 0,
    //       reschedule_appointment_vo: false,
    //       retirement_dollars: 0,
    //       retirement_plan: null,
    //       retirement_plan_spouse: null,
    //       retirement_plan_value: null,
    //       retirement_plan_value_spouse: null,
    //       review: 1,
    //       reviewer_id: 1,
    //       reviewer_user: {
    //         active: true,
    //         address: null,
    //         address_cont: null,
    //         admin: true,
    //         appointment_hours: null,
    //         auto_underlying_limit: "",
    //         calendly_access_token: null,
    //         calendly_expires_in: null,
    //         calendly_organization: null,
    //         calendly_refresh_token: null,
    //         calendly_rs_setup_appointment: null,
    //         calendly_vo_setup_appointment: null,
    //         carrier: null,
    //         city: null,
    //         company_name: "B File Admin System",
    //         coupon_code: null,
    //         created_on: "2015-12-03T12:30:40-05:00",
    //         default_date: 15,
    //         email: "bfileadmin@bfilesystem.com",
    //         email_cron_notification: 0,
    //         email_game_notification: 0,
    //         email_sale_notification: 1,
    //         email_stats_notification: 1,
    //         email_status: 0,
    //         first_name: "BFile",
    //         hidden: false,
    //         home_underlying_limit: "",
    //         id: 1,
    //         invited_by: 19,
    //         jobs: null,
    //         language: null,
    //         last_login: "2023-07-12T13:31:45",
    //         last_login_temp: "2016-06-11T16:01:07",
    //         last_name: "Admin",
    //         minimum_liability_limits: null,
    //         minimum_liability_limits_ext: null,
    //         mobile_number: null,
    //         password:
    //           "pbkdf2:sha1:1000$FwDgXj14$ae298bc77f9a1a2182f94eea8d9a9695d68f71c4",
    //         password_reset_token: "bf199fe6-9e59-4c82-8fc2-b4cc65a4a040",
    //         phone: "111-111-1111",
    //         phone_ext: null,
    //         registration_token: null,
    //         reward_program_enabled: null,
    //         state: null,
    //         stripe_card_id: null,
    //         stripe_customer_id: null,
    //         stripe_onboard_subscription_id: null,
    //         stripe_subscription_id: null,
    //         subscription: null,
    //         suggested_minimum_life_insurance: null,
    //         super_admin: true,
    //         tango_card_amount: null,
    //         tango_card_token: null,
    //         tango_card_token_v2: null,
    //         tango_customer: null,
    //         tango_identifier: null,
    //         tango_identifier_v2: null,
    //         timezone: "US/Eastern",
    //         timezone_offset: "-5",
    //         update_token: null,
    //         updated_on: "2015-12-03T12:30:40-05:00",
    //         user_note: null,
    //         user_tier: null,
    //         user_type: "SUPER_ADMIN",
    //         virtual_link: null,
    //         vob_financial_advisor: null,
    //         zipcode: null,
    //       },
    //       rollover_dollars_created: null,
    //       rollover_opportunities: 0,
    //       rs_action: null,
    //       rs_appointment_date: null,
    //       rs_archived: null,
    //       rs_attempts: null,
    //       rs_call_made: 0,
    //       rs_date: null,
    //       rs_effective_date: "2023-06-22",
    //       rs_notreached_date: null,
    //       rs_policy_type: null,
    //       rs_scheduled_date: null,
    //       secondary_home_market_value: null,
    //       secondary_home_mortgage: null,
    //       secondary_home_mortgage_toggle: null,
    //       secondary_home_toggle: null,
    //       secondary_home_type: null,
    //       secondary_mortgage_protection_benefit: null,
    //       secondary_mortgage_protection_policy: null,
    //       secondary_mortgage_protection_toggle: null,
    //       secondary_vehicles: null,
    //       secondary_vehicles_toggle: null,
    //       secondary_vehicles_value: null,
    //       sent_to_efs_date: null,
    //       sp_500: 0,
    //       sp_date: null,
    //       sp_price: null,
    //       spouse_birthday: null,
    //       spouse_first_name: null,
    //       spouse_last_name: null,
    //       spouse_toggle: null,
    //       state: null,
    //       status: "Renewal",
    //       status_spouse: null,
    //       sub_type_of_call: "Life Insurance",
    //       timezone: "US/Eastern",
    //       token: "ab01e855-e6e2-4e34-ab29-8ba7a6",
    //       twitter: null,
    //       type_of_call: "Review",
    //       umbrella_limit: null,
    //       umbrella_policy_quoted: 0,
    //       umbrella_policy_sold: 0,
    //       umbrella_policy_uncovered: 0,
    //       updated_on: "2023-06-22T08:55:04-04:00",
    //       user: {
    //         active: true,
    //         address: null,
    //         address_cont: null,
    //         admin: false,
    //         appointment_hours: null,
    //         auto_underlying_limit: "",
    //         calendly_access_token:
    //           "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjg2NTc1NTY5LCJqdGkiOiI2OWY0ZTUzMy0wYmQ3LTQ2MTAtYWFjNC04YmEyOWZmMjdlZDciLCJ1c2VyX3V1aWQiOiI3ODJlZGVmOS00NjU3LTRlNTAtYjZiZS0zOWYyODZmMGRmNzkiLCJhcHBfdWlkIjoiaFVBTHN2cXZUOTFKTkI4Y3JOSmlBaFFaR3dSQjA5anJpWnNMZlhmaEdfRSIsImV4cCI6MTY4NjU4Mjc2OX0.mfNLj7yPnoTsRJ6YdL6q8evM_OpiUsDeABnL7v3Gj6ZnKUQchVv078sIJAA2CCz2fMAs3m02rpSPSc-L4xv8Vw",
    //         calendly_expires_in: "2023-06-12T20:36:40",
    //         calendly_organization:
    //           "https://api.calendly.com/organizations/8d153abd-b36a-4b64-b255-5a95f74b547a",
    //         calendly_refresh_token:
    //           "DYhOzXMO3AyPUPhCc5EPw9muoaxhJVm5GyPXEOJeUME",
    //         calendly_rs_setup_appointment:
    //           "https://api.calendly.com/event_types/186a7973-4b10-4d32-a88a-ff1d58f45d27",
    //         calendly_vo_setup_appointment:
    //           "https://api.calendly.com/event_types/78d2b324-c7ad-4e12-9ddb-fad4875f7e45",
    //         carrier: "Farm Bureau",
    //         city: null,
    //         company_name: "FB-Test Insurance Agency",
    //         coupon_code: null,
    //         created_on: "2015-12-03T12:31:19-05:00",
    //         default_date: null,
    //         email: "jamie+fbtest@hoopinsure.com",
    //         email_cron_notification: 1,
    //         email_game_notification: 1,
    //         email_sale_notification: 1,
    //         email_stats_notification: 1,
    //         email_status: 0,
    //         first_name: "FB-Test Account",
    //         hidden: false,
    //         home_underlying_limit: "",
    //         id: 19,
    //         invited_by: 19,
    //         jobs: null,
    //         language: null,
    //         last_login: "2022-07-20T14:16:20",
    //         last_login_temp: "2016-06-14T12:32:40",
    //         last_name: "Agency Owner",
    //         minimum_liability_limits: null,
    //         minimum_liability_limits_ext:
    //           '{"Home":"$100,000","Secondary Home":"$100,000","MFG Home":"$300,000","Renter":"$500,000","Condominium":"$300,000","Landlord":"$500,000","Auto":"$25,000/$50,000","Classic Car":"$25,000/$50,000","RV":"$100,000/$300,000","Boat":"$25,000/$50,000","Motorcycle":"$50,000/$100,000","Golf Cart":"$50,000/$100,000","Off Road":"$25,000/$50,000"}',
    //         mobile_number: null,
    //         phone: null,
    //         phone_ext: null,
    //         reward_program_enabled: 1,
    //         state: null,
    //         stripe_onboard_subscription_id: null,
    //         suggested_minimum_life_insurance: null,
    //         super_admin: false,
    //         tango_card_amount: null,
    //         tango_card_token: "1200126796",
    //         tango_card_token_v2: null,
    //         tango_customer: "0",
    //         tango_identifier: "bfile_user_19",
    //         tango_identifier_v2: null,
    //         timezone: "US/Eastern",
    //         timezone_offset: "-5",
    //         update_token: null,
    //         updated_on: "2015-12-03T12:31:19-05:00",
    //         user_note: null,
    //         user_tier: null,
    //         user_type: "EA",
    //         virtual_link: null,
    //         vob_financial_advisor: null,
    //         zipcode: "48323",
    //       },
    //       user_id: 19,
    //       vip: 0,
    //       vo_claim_date: null,
    //       vo_sent_date: null,
    //       vob_archived: null,
    //       vob_attempted: null,
    //       vob_completed: null,
    //       von_appointment_date: null,
    //       vonboard: null,
    //       zipcode: null,
    //     },
    //   ],
    //   page: 1,
    //   total_pages: 1,
    // };

    // this.setState({
    //   loading: false,
    //   bfiles: res.data.objects,
    //   page: res.data.page,
    //   total_pages: res.data.total_pages,
    // });
  };

  componentWillUnmount() {
    DataHandler.setDncCustomerCallback(null);
  }

  getDncBFiles = (page) => {
    const nPage = page === undefined ? 1 : page;
    const api =
      "/api/b_file?page=" +
      nPage +
      '&q={"filters":[{"name":"dnc_status","op":"==","val":"1"}]}';

    this.setState({ loading: true });

    axios.get(api).then((res) => {
      this.setState({
        loading: false,
        bfiles: res.data.objects,
        page: res.data.page,
        total_pages: res.data.total_pages,
      });
    });
  };

  render() {
    const { loading, bfiles, page, total_pages } = this.state;

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 200,
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
        width: 200,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 200,
      },
      {
        title: "Agency",
        dataIndex: "agency",
        key: "agency",
      },
      {
        title: "DNC Type",
        dataIndex: "dnc_type",
        key: "dnc_type",
        width: 200,
      },
      {
        title: "Who Created",
        dataIndex: "who_created",
        key: "who_created",
        width: 200,
      },
    ];

    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      let bfile = bfiles[i];

      let creator_name = "";
      if (bfile.user !== null) {
        creator_name = bfile.user.first_name + ". " + bfile.user.last_name;
      }

      data.push({
        key: i,
        name: (
          <div className="autoHandleContentStyle" style={{ width: 150 }}>
            {bfile.first_name + " " + bfile.last_name}
          </div>
        ),
        phone: (
          <a href={"tel:" + F.phone_format(bfile.phone)}>
            {F.phone_format(bfile.phone)}
          </a>
        ),
        email: bfile.email,
        agency: bfile.agency.name,
        dnc_type: bfile.dnc_type ? bfile.dnc_type.toUpperCase() : "",
        who_created: creator_name,
      });
    }

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Do Not Call Users`} />
            </div>
          }
          className="tableCard"
          loading={loading}
        >
          <Table
            columns={columns}
            dataSource={data}
            bordered={false}
            pagination={false}
            locale={{ emptyText: "No Data To Show" }}
          />
          <Pagination
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.getDncBFiles(page);
            }}
          />
        </Card>
      </div>
    );
  }
}

export default DncCustomers;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/dnc-customers.js